import { get, post } from './axios.js'

/**
 * 담당자  상세 조회 - /mng/mngSelect
 * @param {Object} params
 * @property {Number} params.mng_seq - 매니저 seq
 * @returns
 */
export async function mngSelect(params = {}) {
  try {
    const result = await post('/mng/mngSelect', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}


/**
 * 담당자 등록/수정 - /mng/mngEdit
 * @param {Object} params
 * @property {Number} params.mng_seq - 매니저 seq
 * @property {Number} params.cp_seq - 회사관리번호
 * @property {string} params.mngr_nm - 담당자명
 * @property {string} params.postion -직급
 * @property {string} params.depart_nm -부서
 * @property {string} params.mobile - 핸드폰번호
 * @property {string} params.tel_no - 전화번호
 * @property {string} params.email - 이메일
 * @property {string} params.memo - 메모
 * @property {string} params.keyman_yn -keyman
 * @property {string} params.trend_cd - 성향코드
 * @property {string} params.enable_yn - (비)활성
 * @property {string} params.attch_pic_id - 첨부파일 사진 id 
 * @property {string} params.ss_user_id - 로그인 유저 id
 * @property {string} params.bkmark_yn - 즐겨찾기
 * @property {string} params.retire_yn - 퇴직여부
 * @property {string} params.tmp_yn - 임시저장(Y:임시저장,N:완료)
 * @returns
 */
export async function mngEdit(params = {}) {
  try {
    const result = await post('/mng/mngEdit', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}


/**
 * 담당자 목록 조회 - /mng/mngList
 * @param {Object} params
 * @property {string} params.cmp_nm - 회사명
 * @property {string} params.cmp_dvsn_nm - 사업부명
 * @property {string} params.business_no - 사업자등록번호
 * @property {string} params.mngr_nm -담당자명
 * @property {string} params.depart_nm -부서
 * @returns
 */
export async function mngList(params = {}) {
  try {
    const result = await post('/mng/mngList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}